var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{ref:"overviewmapPanel",staticClass:"pa-1",attrs:{"width":_vm.width,"height":_vm.height,"elevation":"8"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebfda584","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/overviewmap/OverviewMapPanel.vue
// module id = Ss2k
// module chunks = 1